<app-faq-hero></app-faq-hero>
<app-faq-list></app-faq-list>
<app-follow></app-follow>
<app-category-news></app-category-news>
<app-donors></app-donors>